import { Heart, ArrowUpRight } from "lucide-react";
import { Seo } from "../components/Seo";
import { PageHeader, CTAButton, Kicker } from "../components/Bits";
import { Reveal } from "../components/Reveal";
import { EVENT, LINKS, IMAGES } from "../lib/site";

const AMOUNTS = ["$25", "$50", "$100", "$250"];
const IMPACT = [
  { amt: "$25", text: "Sponsors a race kit for a participant who needs support." },
  { amt: "$50", text: "Funds an hour of inclusive recreation programming." },
  { amt: "$100", text: "Supports employment coaching for one participant." },
  { amt: "$250", text: "Helps launch a new community inclusion initiative." },
];

export default function Donate() {
  return (
    <>
      <Seo title="Donate" path="/donate" description={`Donate to ${EVENT.charity} through the Grimsby On The Lake Turkey Trot.`} />
      <PageHeader
        chapter="give back"
        title="Every dollar goes further."
        sub={`Can't make it on race day? You can still make a difference. 100% of donations support ${EVENT.charity}.`}
        image={IMAGES.charity}
      />

      <section className="mx-auto max-w-5xl px-5 sm:px-8 pb-16">
        <Reveal>
          <div className="rounded-3xl bg-white border border-black/5 shadow-warm p-8 sm:p-12">
            <Kicker>choose an amount</Kicker>
            <div className="mt-5 flex flex-wrap gap-3">
              {AMOUNTS.map((a) => (
                <a key={a} href={LINKS.donate} target="_blank" rel="noopener noreferrer"
                  className="px-7 py-4 rounded-2xl bg-cream-200 font-display text-2xl font-semibold hover:bg-terracotta hover:text-white transition-colors duration-200"
                  data-testid={`donate-${a.replace('$','')}`}>
                  {a}
                </a>
              ))}
            </div>
            <div className="mt-8">
              <CTAButton href={LINKS.donate} variant="forest">
                <Heart size={16} /> Donate now <ArrowUpRight size={16} />
              </CTAButton>
            </div>
          </div>
        </Reveal>
      </section>

      <section className="mx-auto max-w-5xl px-5 sm:px-8 pb-24 sm:pb-32">
        <h2 className="font-display text-3xl font-semibold mb-8">Your impact</h2>
        <div className="grid gap-5 sm:grid-cols-2">
          {IMPACT.map((it, i) => (
            <Reveal key={it.amt} delay={i * 0.06}>
              <div className="flex items-start gap-4 rounded-2xl bg-white border border-black/5 p-6 shadow-warm">
                <span className="font-display text-3xl font-semibold text-terracotta shrink-0">{it.amt}</span>
                <p className="text-ink-soft leading-relaxed">{it.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
